import { Table, TableBody, TableCell, TableFooter, TableRow } from "@material-ui/core";
import { calculateQuarterly, calculateYearly, formatMoneyCents } from "../../helpers";
import { BlackCellBorderWhite, BrightYellowCellBorder, LightGreyCell, StyledTableRow } from "../Page/TableStyles";

export default function MaximumSavingsTable(props) {
    const {formData, dailyProduction} = props;

    return (
        <Table size='small'>
            <TableBody>
                <StyledTableRow>
                    <BlackCellBorderWhite>
                        Maximum Savings Breakdown
                    </BlackCellBorderWhite>
                </StyledTableRow>
                <StyledTableRow>
                    <BrightYellowCellBorder>Daytime Usage</BrightYellowCellBorder>
                    <BrightYellowCellBorder>KWH Daily</BrightYellowCellBorder>
                    <BrightYellowCellBorder>Current KWH Rate</BrightYellowCellBorder>
                    <BrightYellowCellBorder>Daily Savings</BrightYellowCellBorder>
                    <BrightYellowCellBorder>Quarterly Savings</BrightYellowCellBorder>
                    <BrightYellowCellBorder>Annual Savings</BrightYellowCellBorder>
                </StyledTableRow>
                <StyledTableRow>
                    <BlackCellBorderWhite>100%</BlackCellBorderWhite>
                    <LightGreyCell>{dailyProduction}</LightGreyCell>
                    <LightGreyCell>{formatMoneyCents(formData.powerPrice)}</LightGreyCell>
                    <LightGreyCell>{formatMoneyCents(formData.powerPrice * dailyProduction)}</LightGreyCell>
                    <LightGreyCell>{formatMoneyCents(calculateQuarterly(formData.powerPrice * dailyProduction))}</LightGreyCell>
                    <LightGreyCell>{formatMoneyCents(calculateYearly(formData.powerPrice * dailyProduction))}</LightGreyCell>
                </StyledTableRow>
            </TableBody>
            <TableFooter>
                <TableRow>
                    <TableCell colSpan={6}>
                        Your maximum savings breakdown is based on if you were able to use all energy produced by the solar system, this essentially shows the capacity
                    </TableCell>
                </TableRow>
            </TableFooter>
        </Table>
    )
}